import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import API_URL from '../../config';
import './MyReservations.css';

function MyReservations() {
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getAuthHeader } = useAuth();

  useEffect(() => {
    fetchMyReservations();
    // Poll for updates every 30 seconds
    const interval = setInterval(fetchMyReservations, 30000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchMyReservations = async () => {
    try {
      const response = await fetch(`${API_URL}/api/reservations/my-reservations`, {
        headers: getAuthHeader()
      });
      const data = await response.json();
      // Ensure data is an array (API may return error object)
      setReservations(Array.isArray(data) ? data : []);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching reservations:', error);
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      pending: { class: 'badge-pending', text: 'Pending' },
      approved: { class: 'badge-approved', text: 'Approved' },
      rejected: { class: 'badge-rejected', text: 'Rejected' }
    };
    return badges[status] || badges.pending;
  };

  if (loading) return <div className="loading">Loading your reservations...</div>;

  return (
    <div className="my-reservations">
      <h2>My Reservations</h2>

      {reservations.length === 0 ? (
        <div className="empty-state">
          <p>You haven't made any reservation requests yet.</p>
          <p>Start by chatting with our AI assistant to book your stay!</p>
        </div>
      ) : (
        <div className="reservations-grid">
          {reservations.map(res => {
            const badge = getStatusBadge(res.status);
            return (
              <div key={res.id} className={`reservation-card ${res.status}`}>
                <div className="reservation-header">
                  <div className="reservation-badges">
                    <span className={`status-badge ${badge.class}`}>
                      {badge.text}
                    </span>
                    {res.is_member && (
                      <span className="status-badge badge-member">Member</span>
                    )}
                  </div>
                  <span className="reservation-id">#{res.id}</span>
                </div>

                <div className="reservation-dates">
                  <div className="date-block">
                    <label>Check-in</label>
                    <div className="date">{new Date(res.check_in_date).toLocaleDateString()}</div>
                  </div>
                  <div className="arrow">→</div>
                  <div className="date-block">
                    <label>Check-out</label>
                    <div className="date">{new Date(res.check_out_date).toLocaleDateString()}</div>
                  </div>
                </div>

                <div className="reservation-meta">
                  <p><strong>Requested:</strong> {new Date(res.created_at).toLocaleDateString()}</p>
                  {res.status === 'approved' && res.approved_at && (
                    <p className="approved-text">
                      <strong>Approved:</strong> {new Date(res.approved_at).toLocaleDateString()}
                    </p>
                  )}
                  {res.status === 'rejected' && res.rejected_at && (
                    <p className="rejected-text">
                      <strong>Rejected:</strong> {new Date(res.rejected_at).toLocaleDateString()}
                    </p>
                  )}
                </div>

                <Link to={`/reservations/${res.id}`} className="view-details-link">
                  View Details →
                </Link>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default MyReservations;
